export class ResetPasswordModel {
  email = '';
}
